import React from "react";
import { Create, SimpleForm, NumberInput, BooleanInput } from "react-admin";
import Grid from "@material-ui/core/Grid";
import CreateToolbar from "../Custom/create-save-button";
import { makeStyles } from "@material-ui/core/styles";
import { validateRequired } from "../../utils/Validations";
import CustomAdminSelect from "../BestSellers/CustomAdminSelect";

const useStyles = makeStyles({
    container: {
        width: "100%",
    },
});

const PreciousPricingCreate = (props) => {
    const classes = useStyles();

    return (
        <Create {...props} className="overflow-visible">
            <SimpleForm toolbar={<CreateToolbar />}>
                <Grid container className={classes.container} spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <CustomAdminSelect
                            label="Precious Metal Type"
                            source="precious_metal_type_id"
                            resource="precious-metal-types"
                            optionValue="precious_metal_type_id"
                            optionLabel="name"
                            validate={validateRequired}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <BooleanInput
                            source="cast"
                            label="Cast"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <NumberInput
                            source="markup"
                            label="Markup"
                            validate={[validateRequired]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <NumberInput
                            source="cost"
                            label="Cost"
                            validate={[validateRequired]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <NumberInput
                            source="market_multiplyer"
                            label="Market Multiplier"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <NumberInput source="additional" label="Additional" fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <NumberInput
                            source="ruth_multiplier"
                            label="Ruth Multiplier"
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </SimpleForm>
        </Create>
    );
};

export default PreciousPricingCreate;
